import React from "react";

import { Wrapper, Row } from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
const SubmitButton = props => {
  if (props.checkIfAllPropertyAddressFieldsAreSelected()) {
    return (
      <Row style={{ justifyContent: "flex-end" }}>
        <PillButton
          primary={true}
          onPress={() => {
            props.submitList();
          }}
        >
          Add Properties and Lookup Owner Info
        </PillButton>
      </Row>
    );
  }

  return <Wrapper style={{ flex: 1 }} />;
};

export default React.memo(SubmitButton);
